import * as actionsType from './../actions/types.js';

const initialState = {
  showAlert: false,
  alertText: ''
};

export default function alertReducer(state = initialState,action){
  switch(action.type) {
    case actionsType.SET_SHOW_ALERT:{
      return ({...state,showAlert: action.show,alertText: action.text});
    }
    default: return state;
  }
}
